// SwingEdge — swingedge.js v2
// Cart drawer + addToCart + color swatches + FAB + notifications + FAQ

var SE = (function() {

  function formatMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2) + ' AUD';
  }

  // ── CART COUNT ──
  function updateCartCount(count) {
    document.querySelectorAll('[data-se-cart-count]').forEach(function(el) {
      el.textContent = count;
    });
    // Update FAB
    var fab = document.getElementById('seCartFab');
    var fabCount = document.getElementById('seCartFabCount');
    if (fab) {
      if (count > 0) {
        fab.classList.add('visible');
        if (fabCount) fabCount.textContent = count;
      } else {
        fab.classList.remove('visible');
      }
    }
  }

  // ── FETCH CART ──
  function fetchCart(cb) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(cb)
      .catch(function() {});
  }

  // ── ADD TO CART ──
  // Detects if btn is a color swatch (round) or a regular ATC button
  function addToCart(variantId, btnEl) {
    if (!variantId) return;
    var btn = btnEl || null;

    // Check if it's a color swatch button
    var isSwatch = btn && (
      btn.classList.contains('se-color-swatch') ||
      btn.dataset.swatch === 'true'
    );

    if (btn && !isSwatch) {
      btn.disabled = true;
      btn.textContent = 'Adding...';
    }
    if (btn && isSwatch) {
      // Show selected state on swatch
      var parent = btn.parentElement;
      if (parent) {
        parent.querySelectorAll('.se-color-swatch').forEach(function(s) {
          s.style.outline = '';
          s.style.outlineOffset = '';
          s.style.transform = '';
        });
      }
      btn.style.outline = '3px solid var(--fairway)';
      btn.style.outlineOffset = '2px';
      btn.style.transform = 'scale(1.15)';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function(r) { if (!r.ok) throw new Error('Error'); return r.json(); })
    .then(function() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      if (btn && !isSwatch) {
        btn.textContent = '✓ Added!';
        btn.style.background = 'var(--fairway-bright)';
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
        }, 1500);
      }
      if (btn && isSwatch) {
        // Keep selected state, reset after 2s
        setTimeout(function() {
          btn.style.outline = '2px solid var(--fairway)';
          btn.style.outlineOffset = '1px';
          btn.style.transform = '';
        }, 1500);
      }
      openDrawer();
    })
    .catch(function() {
      if (btn && !isSwatch) {
        btn.disabled = false;
        btn.textContent = 'Try Again';
      }
      if (btn && isSwatch) {
        btn.style.outline = '';
        btn.style.outlineOffset = '';
        btn.style.transform = '';
      }
    });
  }
  window.addToCart = addToCart;

  // ── ADD TO CART WITH QUANTITY (PDP) ──
  function addToCartQty(variantId, quantity, btnEl) {
    if (!variantId) return;
    var btn = btnEl || null;
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) || 1 })
    })
    .then(function(r) { if (!r.ok) throw new Error('Error'); return r.json(); })
    .then(function() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      if (btn) {
        btn.innerHTML = '✓ Added!';
        setTimeout(function() { btn.disabled = false; btn.innerHTML = label; }, 1500);
      }
      openDrawer();
    })
    .catch(function() { if (btn) { btn.disabled = false; btn.innerHTML = 'Try Again'; } });
  }
  window.addToCartQty = addToCartQty;

  // ── CART DRAWER ──
  var drawerBuilt = false;

  function buildDrawer() {
    if (drawerBuilt) return;
    drawerBuilt = true;
    var el = document.createElement('div');
    el.id = 'seCartDrawer';
    el.innerHTML =
      '<div class="se-drawer-overlay" id="seOverlay"></div>' +
      '<div class="se-drawer" id="sePanel">' +
        '<div class="se-drawer-head">' +
          '<span class="se-drawer-title">Your Cart 🛒</span>' +
          '<button class="se-drawer-close" id="seDrawerClose" aria-label="Close">✕</button>' +
        '</div>' +
        '<div class="se-drawer-body" id="seDrawerBody">' +
          '<div style="padding:2rem;text-align:center;color:var(--text-3);font-size:0.85rem;">Loading...</div>' +
        '</div>' +
        '<div class="se-drawer-foot" id="seDrawerFoot" style="display:none;">' +
          '<div class="se-subtotal-row"><span>Subtotal</span><span id="seTotal">$0.00 AUD</span></div>' +
          '<p class="se-shipping-note" id="seShipNote"></p>' +
          '<a href="/checkout" class="se-checkout-btn">Checkout →</a>' +
          '<a href="/" class="se-continue-btn" id="seContinue">← Continue Shopping</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    document.getElementById('seDrawerClose').addEventListener('click', closeDrawer);
    document.getElementById('seOverlay').addEventListener('click', closeDrawer);
    document.getElementById('seContinue').addEventListener('click', function(e) {
      e.preventDefault(); closeDrawer();
    });
  }

  function openDrawer() {
    buildDrawer();
    document.getElementById('sePanel').classList.add('open');
    document.getElementById('seOverlay').classList.add('open');
    document.body.style.overflow = 'hidden';
    renderDrawer();
  }
  window.openCartDrawer = openDrawer;

  function closeDrawer() {
    var panel = document.getElementById('sePanel');
    var overlay = document.getElementById('seOverlay');
    if (panel) panel.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.closeCartDrawer = closeDrawer;

  function renderDrawer() {
    fetchCart(function(cart) {
      var body = document.getElementById('seDrawerBody');
      var foot = document.getElementById('seDrawerFoot');
      var totalEl = document.getElementById('seTotal');
      var shipNote = document.getElementById('seShipNote');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="se-drawer-empty">' +
            '<div class="se-drawer-empty-icon">⛳</div>' +
            '<p>Your cart is empty</p>' +
            '<button class="se-drawer-shop-btn" onclick="closeCartDrawer()">Shop Training Aids</button>' +
          '</div>';
        if (foot) foot.style.display = 'none';
        return;
      }

      var html = '<ul class="se-cart-items">';
      cart.items.forEach(function(item) {
        html +=
          '<li class="se-cart-item" data-variant="' + item.variant_id + '">' +
            '<div class="se-item-img">' +
              (item.image
                ? '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">'
                : '<span style="font-size:1.5rem">⛳</span>') +
            '</div>' +
            '<div class="se-item-info">' +
              '<p class="se-item-title">' + item.product_title + '</p>' +
              (item.variant_title && item.variant_title !== 'Default Title'
                ? '<p class="se-item-variant">' + item.variant_title + '</p>' : '') +
              '<p class="se-item-price">' + formatMoney(item.final_price) + '</p>' +
              '<div class="se-qty-row">' +
                '<div class="se-qty">' +
                  '<button class="se-qty-btn" data-action="dec" data-variant="' + item.variant_id + '" data-qty="' + item.quantity + '">−</button>' +
                  '<span class="se-qty-num">' + item.quantity + '</span>' +
                  '<button class="se-qty-btn" data-action="inc" data-variant="' + item.variant_id + '" data-qty="' + item.quantity + '">+</button>' +
                '</div>' +
                '<span class="se-item-line">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button class="se-item-remove" data-variant="' + item.variant_id + '" aria-label="Remove">✕</button>' +
          '</li>';
      });
      html += '</ul>';
      body.innerHTML = html;

      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      var THRESHOLD = 6000;
      if (shipNote) {
        if (cart.total_price >= THRESHOLD) {
          shipNote.innerHTML = '✅ <strong>Free shipping</strong> applied!';
          shipNote.className = 'se-shipping-note se-shipping-ok';
        } else {
          shipNote.innerHTML = '📦 Add <strong>' + formatMoney(THRESHOLD - cart.total_price) + '</strong> more for free shipping';
          shipNote.className = 'se-shipping-note';
        }
      }
      if (foot) foot.style.display = 'block';

      body.querySelectorAll('.se-qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var vid = btn.dataset.variant;
          var qty = parseInt(btn.dataset.qty, 10);
          var newQty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(0, qty - 1);
          changeQty(vid, newQty);
        });
      });
      body.querySelectorAll('.se-item-remove').forEach(function(btn) {
        btn.addEventListener('click', function() { changeQty(btn.dataset.variant, 0); });
      });
      updateCartCount(cart.item_count);
    });
  }

  function changeQty(variantId, newQty) {
    var item = document.querySelector('[data-variant="' + variantId + '"]');
    if (item) item.style.opacity = '0.5';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: newQty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { updateCartCount(cart.item_count); renderDrawer(); })
    .catch(function() { if (item) item.style.opacity = '1'; });
  }

  // ── FAQ ──
  function toggleFaq(btn) {
    var item = btn.parentElement;
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.se-faq-item.open').forEach(function(i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  }
  window.toggleFaq = toggleFaq;

  // ── EXIT INTENT ──
  function initExitIntent() {
    var shown = false;
    var overlay = document.getElementById('seExitOverlay');
    if (!overlay) return;
    function showPopup() {
      if (shown) return;
      shown = true;
      overlay.style.pointerEvents = 'all';
      overlay.style.opacity = '1';
      var modal = overlay.querySelector('.se-exit-modal');
      if (modal) modal.style.transform = 'scale(1)';
    }
    window.closeExitPopup = function() {
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
      var modal = overlay.querySelector('.se-exit-modal');
      if (modal) modal.style.transform = 'scale(0.9)';
    };
    overlay.addEventListener('click', function(e) { if (e.target === overlay) window.closeExitPopup(); });
    document.addEventListener('mouseleave', function(e) { if (e.clientY <= 10) showPopup(); });
    setTimeout(function() { if (!shown && window.innerWidth < 768) showPopup(); }, 40000);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') window.closeExitPopup(); });
  }

  // ── INIT ──
  document.addEventListener('DOMContentLoaded', function() {

    // Cart count + FAB on load
    fetchCart(function(cart) { updateCartCount(cart.item_count); });

    // Cart links open drawer
    document.querySelectorAll('[data-se-cart-open]').forEach(function(el) {
      el.addEventListener('click', function(e) { e.preventDefault(); openDrawer(); });
    });

    // Sticky ATC bar
    var stickyBar = document.getElementById('seStickyBar');
    var stickyBtn = document.getElementById('seStickyBtn');
    var hero = document.querySelector('.se-hero');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var firstAtc = document.querySelector('.se-card-atc');
        if (firstAtc) firstAtc.click();
      });
    }
    if (stickyBar && hero) {
      window.addEventListener('scroll', function() {
        stickyBar.classList.toggle('visible', window.scrollY > hero.offsetHeight + 100);
      }, { passive: true });
    }

    // Fade-in on scroll
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.se-fade-up').forEach(function(el) { observer.observe(el); });

    // ESC closes drawer
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });

    // Make entire product card clickable (mobile + desktop)
    document.querySelectorAll('.se-product-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        // Don't navigate if clicking a button or swatch
        if (e.target.closest('button') || e.target.closest('.se-card-atc')) return;
        // Find the product link from the card image anchor
        var link = card.querySelector('a[href]');
        if (link && link.href) {
          window.location.href = link.href;
        }
      });
    });

    buildDrawer();
    initExitIntent();
  });

})();
